import 'core-js/modules/es.object.assign.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useUtility, Stack } from '@hub-la/design-system';
import { Skeleton } from '@mui/material';

const CardLoading = () => {
  const {
    palette
  } = useUtility();
  return jsx(Stack, Object.assign({
    direction: "row",
    alignItems: "center",
    border: 1.5,
    borderColor: palette('surfaceVariant'),
    p: 4,
    borderRadius: 4,
    justifyContent: "space-between"
  }, {
    children: jsxs(Stack, Object.assign({
      direction: "row",
      gap: 4,
      alignItems: "center"
    }, {
      children: [jsx(Stack, {
        children: jsx(Skeleton, {
          variant: "circular",
          width: 40,
          height: 40
        })
      }), jsxs(Stack, {
        children: [jsx(Skeleton, {
          variant: "text",
          width: 150
        }), jsx(Skeleton, {
          variant: "text",
          width: 250
        })]
      })]
    }))
  }));
};
const SelectAccountLoadingState = () => {
  return jsxs(Fragment, {
    children: [jsx(CardLoading, {}), jsx(CardLoading, {}), jsx(CardLoading, {})]
  });
};

export { SelectAccountLoadingState };
